import { useMemo } from "react";
import { useUser } from "../../../classes/contexts/UserContext";

export const useSettings = () => {
  const {
    userPreferences,
    preferencesLoading,
    preferencesError,
    updateUserTimezone,
    updateUserLengthUnit,
    updateUserWeightUnit,
    updateFloatSensitivity,
    updateKeyParameters,
    refreshUserPreferences,
  } = useUser();

  const displaySettings = userPreferences?.display_settings;
  const units = useMemo(
    () => ({
      length: displaySettings?.length_unit || "cm",
      weight: displaySettings?.weight_unit || "kg",
    }),
    [displaySettings?.length_unit, displaySettings?.weight_unit]
  );

  const timezone = displaySettings?.timezone || "UTC";
  const floatSensitivity = displaySettings?.float_sensitivity ?? 1.0;
  const keyParameters = userPreferences?.spino_pelvic_parameters || [];

  return {
    userPreferences,
    preferencesLoading,
    preferencesError,
    units,
    timezone,
    floatSensitivity,
    keyParameters,
    updateUserTimezone,
    updateUserLengthUnit,
    updateUserWeightUnit,
    updateFloatSensitivity,
    updateKeyParameters,
    refreshUserPreferences,
  };
};
